import { GameVars } from "../../GameVars";

export class ResultTurret extends Phaser.GameObjects.Container {

    constructor(scene: Phaser.Scene, info: any, x: number, y: number) {

        super(scene);

        this.x = x; 
        this.y = y;

        let turretKeys = Object.keys(GameVars.turretsData);

        let index = 0;

        for (let i = 0; i < turretKeys.length; i++) {
            if (turretKeys[i] === info.type) {
                index = i;
                break;
            }
        }

        let img = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_2", "tower_image_" + (index + 1) + "_" + info.level);
        img.setScale(.55);
        this.add(img);

        let text = new Phaser.GameObjects.Text(this.scene, 0, 50, "c: " + info.p.c + "\nr: " + info.p.r + "\nLVL: " + info.level, {fontFamily: "Rubik-Bold", fontSize: "15px", color: "#000000", align: "center"});
        text.setOrigin(.5);
        text.lineSpacing = -10;
        this.add(text);
    }
}
